import { Accordion, Box, Button, Link, Text, useSlotRecipe, VStack } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { modifyLink } from '@app/helpers/navigation.helpers';
import { ContentLinkGroupModel, ContentLinkModel } from '@app/models';

import { AccordionMenuItemProps } from './accordion-menu-item.props';

const InnerMenuLink = ({ subLink }: { subLink: ContentLinkModel }): JSX.Element => (
    <Link href={modifyLink(subLink)} variant={'menuLinkInner'}>
        {subLink.label}
    </Link>
);

export const AccordionMenuItem = ({
    index,
    currentItemIndex,
    navLink,
    isOpen,
    onMenuClick,
}: AccordionMenuItemProps) => {
    const recipe = useSlotRecipe({
        key: 'accordionMenuItem',
    });
    const styles = recipe();

    return currentItemIndex === null || index === currentItemIndex ? (
        <>
            <Button
                variant={'expandableMenuItem'}
                css={{
                    justifyContent: isOpen ? 'flex-start' : 'space-between',
                    fontSize: 'md',
                    py: 2.5,
                    px: isOpen ? 2 : 4,
                    mb: isOpen ? 0 : '3px',
                    _hover: {
                        bg: 'white',
                    },
                }}
                onClick={() => onMenuClick()}
            >
                {isOpen ? <IconsLinear.ArrowLeft2 {...styles.icon} size={'xs'} /> : null}
                <VStack align={'flex-start'} gap={0}>
                    <Text
                        as={'span'}
                        color={'secondary.solid'}
                        fontWeight={isOpen ? 'bold' : undefined}
                    >
                        {navLink.navLinkLabel}
                    </Text>
                    {navLink.excerpt && !isOpen ? (
                        <Text as={'span'} color={'gray.500'} fontSize={'xs'} lineClamp={1}>
                            {navLink.excerpt}
                        </Text>
                    ) : null}
                </VStack>
                {!isOpen ? <IconsLinear.ArrowRight2 {...styles.icon} size={'xs'} /> : null}
            </Button>
            {navLink.hasContentGroups ? (
                <VStack bg={'white'} width={'100%'} gap={0} hidden={!isOpen}>
                    <Accordion.Root collapsible={true} width={'100%'}>
                        {navLink.navLinkContent?.map(
                            (
                                contentGroup: ContentLinkModel | ContentLinkGroupModel,
                                contentIndex: number,
                            ) => (
                                <Accordion.Item
                                    key={contentIndex}
                                    border={'none'}
                                    value={`${contentIndex}`}
                                >
                                    <Accordion.ItemTrigger css={styles.button}>
                                        <Box as={'span'} fontSize={'sm'} px={'1.25rem'} py={2.5}>
                                            {'contentLinksTitle' in contentGroup
                                                ? contentGroup.contentLinksTitle
                                                : null}
                                        </Box>
                                        <Accordion.ItemIndicator css={styles.icon} />
                                    </Accordion.ItemTrigger>
                                    <Accordion.ItemContent>
                                        <Accordion.ItemBody as={VStack} gap={0.5} pl={12}>
                                            {'contentLinks' in contentGroup
                                                ? contentGroup.contentLinks.map(
                                                      (subLink: ContentLinkModel) => (
                                                          <InnerMenuLink
                                                              key={subLink.url}
                                                              subLink={subLink}
                                                          />
                                                      ),
                                                  )
                                                : null}
                                        </Accordion.ItemBody>
                                    </Accordion.ItemContent>
                                </Accordion.Item>
                            ),
                        )}
                    </Accordion.Root>
                </VStack>
            ) : (
                <VStack bg={'white'} width={'100%'} gap={0} pl={8} hidden={!isOpen}>
                    {navLink.navLinkContent?.map(
                        (subLink: ContentLinkModel | ContentLinkGroupModel) =>
                            'url' in subLink ? (
                                <InnerMenuLink key={subLink.url} subLink={subLink} />
                            ) : null,
                    )}
                </VStack>
            )}
        </>
    ) : null;
};
